/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-avi-site-config';
const prefix = `${moduleName}.${componentName}`;

export const enableHealthMonitorShardingLabel = `${prefix}.enableHealthMonitorShardingLabel`;
export const overridePoolMemberRatioLabel = `${prefix}.overridePoolMemberRatioLabel`;

export const ENGLISH = {
    [enableHealthMonitorShardingLabel]: 'Enable Health Monitor Sharding',
    [overridePoolMemberRatioLabel]: 'Override Pool Member Ratio',
};
